import React, { useEffect, useState } from 'react';

import { Spinner, Divider } from '@telus-uds/components-web';

import { TopBarWrapper } from './css';

import request from '../../../../utils/request';

import Add from './components/add';
import TextSearchFilter from '../TextSearchFilter';
import Block from './components/block';

const Dealership = () => {
  const [apiData, setApiData] = useState();
  const [filterString, setFilterString] = useState();

  const fetchData = async () => {
    try {
      const result = await request.get('/dealerships');

      if (result && result.status === 200) {
        setApiData(result.data.rows);
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
    <div className='layout-container'>
      <Divider space={2} variant={{ inverse: true }}/>
      {!apiData && <Spinner show label="Loading data..." />}
      {apiData && (
        <>
          <TopBarWrapper>
            <Add fetchData={fetchData} />
            <TextSearchFilter
              filterString={filterString}
              setFilterString={setFilterString}
              placeholder="Search by dealership..."
            />
          </TopBarWrapper>
          <Divider space={2} variant={{ inverse: true }}/>
          <Block
            data={apiData}
            filterString={filterString}
            fetchData={fetchData}
          />
        </>
      )}
      </div>
    </>
  );
};

export default Dealership;
